import { db } from '../../../context/Firebase';
import { collection, getDocs, doc, getDoc, query, where } from 'firebase/firestore';
import UserRepository from '../../../domain/repositories/UserRepository';
import ChatUser from '../../../domain/entities/ChatUser';

class FirebaseUserRepository extends UserRepository {
    constructor() {
        super();
        this.usersCollection = collection(db, 'users');
    }

    /**
     * Converts a Firestore user document snapshot to a ChatUser entity.
     * @param {DocumentSnapshot} docSnap - The Firestore document snapshot.
     * @returns {ChatUser}
     */
    _toChatUserEntity(docSnap) {
        const data = docSnap.data();
        let dob = null;
        if (data.dob?.toDate) dob = data.dob.toDate();
        else if (data.dob) dob = new Date(data.dob);
        return new ChatUser({
            uid: docSnap.id,
            name: data.name || data.displayName || 'Unknown User',
            email: data.email,
            profilePic: data.picture || null,
            dob,
        });
    }

    async getUsers() {
        console.log('Fetching all users for mass messaging...');
        const querySnapshot = await getDocs(this.usersCollection);
        const users = querySnapshot.docs.map(doc => this._toChatUserEntity(doc));
        console.log(`Found ${users.length} users:`, users.map(u => ({ uid: u.uid, name: u.name })));
        return users;
    }

    async getUserById(uid) {
        const docRef = doc(this.usersCollection, uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return this._toChatUserEntity(docSnap);
        }
        return null;
    }

    async getUserByEmail(email) {
        const q = query(this.usersCollection, where('email', '==', email));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            return this._toChatUserEntity(querySnapshot.docs[0]);
        }
        return null;
    }
}

export default FirebaseUserRepository;
